import { render, staticRenderFns } from "./UserValidation.vue?vue&type=template&id=1e495a3d&scoped=true&"
import script from "./UserValidation.vue?vue&type=script&lang=js&"
export * from "./UserValidation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e495a3d",
  null
  
)

export default component.exports